export default __webpack_public_path__ + "static/media/step1.db92cdc3.png";